<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขรูปภาพแบรนเนอร์เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <div class="mb-3">
                    <h2>จัดการรูปภาพแบรนเนอร์</h2>
                </div>
                <div class="grid_half_content_manage_banner_list">
                    <div class="d-flex justify-center align-center">
                        <div class="example_image_content_manage_banner_list">
                            <img src="@/assets/banner.jpg">
                        </div>
                    </div>
                    <div>
                        <v-card class="mb-3" v-for="(detail,index) in data" :key="index">
                            <div class="pa-3 list_content_manage_banner_list d-flex align-center">
                                <div class="img_slide_content_manage_banner_list">
                                    <img :src="detail.image">
                                </div>
                                <div class="grid_detail_content_manage_banner_list">
                                    <div>
                                        <div>แบรนเนอร์ ที่ {{ index + 1 }}</div>
                                        <div>อัพโหลด : {{ detail.created_at }}</div>
                                        <div>โดย : {{ detail.user_uploade }}</div>
                                    </div>
                                    <!-- <div class="flex-column d-flex align-end">
                                    <div>
                                        แสดงหน้าเว็บไซต์
                                    </div>
                                    <div class="d-flex">
                                        <v-switch class="ma-0 pa-0" hide-details="true" width="10" color="success" @click="changeStatus(detail.id)" v-model="detail.status"></v-switch>
                                    </div>
                                </div> -->
                                </div>
                                <div class="action_content_manage_banner_list">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" width="50">mdi-dots-vertical</v-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item class="cursor_content_manage_banner_list" @click="openBannerEdit(detail.id)">
                                                <v-list-item-title>แก้ไขรูปภาพ</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>

                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </v-card>
        <!-- แก้ไข -->
        <v-dialog v-model="open_image_edit" persistent max-width="600px">
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">
                <v-form @submit.prevent="editBanner()">
                    <v-card-title class="justify-space-between">
                        <div>
                            แก้ไขรูปภาพ
                        </div>
                        <div class="cursor_content_manage_banner_list" @click="open_image_edit = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-img height="330" max-width="280" v-if="imagePreviewURL" :src="imagePreviewURL" class="image_preview_content_manage_banner_list"></v-img>
                                <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="image" label="แก้ไขรูปภาพแบรนเนอร์" @change="onFileChange"></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script src="@/previewimage.js"></script><script>
import before_image from "@/assets/fast-food.png";
import contentbanner from '@/api/content/contentmanageimage/contentbanner.js'
import contentslide from '@/api/content/contentmanageimage/contentslide.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            alert_show_status: false,
            alert_show_edit: false,
            open_image_edit: false,
            edit_id: null,
            imagePreviewURL: before_image,
            image: null,
            data: [],
        }
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async bannerList() {
            this.loading_page = true
            this.data = []
            contentbanner.bannerList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.slide
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openBannerEdit(id) {
            this.loading_page_detail = true
            this.open_image_edit = true
            contentslide.slideDetail(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.detail.id
                    this.imagePreviewURL = response.data.detail.image
                    this.image = null
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async editBanner() {
            this.open_image_edit = false
            this.loading_page = true
            let data = new FormData()
            data.append('image', this.image)
            contentslide.editSlide(this.edit_id, data).then((response) => {
                if (response.data.successful === true) {
                    this.bannerList()
                    this.alert_show_edit = true
                    setTimeout(() => this.alert_show_edit = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async changeStatus(id) {
            contentslide.changeStatusSlide(id).then((response) => {
                if (response.data.successful === true) {
                    this.alert_show_status = true
                    setTimeout(() => this.alert_show_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.bannerList()
    }
}
</script>

<style scoped>
.grid_half_content_manage_banner_list {
    display: grid;
    grid-template-columns: 30% 70%;
}

.example_image_content_manage_banner_list >img {
    max-width: 100%;
}

.list_content_manage_banner_list {
    position: relative;
}

.img_slide_content_manage_banner_list {
    width: 190px;
}

.img_slide_content_manage_banner_list>img {
    max-width: 100%;
}

.grid_detail_content_manage_banner_list {
    width: 100%;
    padding: 0 10px;
    display: grid;
    grid-template-columns: 70% 30%;
}

.action_content_manage_banner_list {
    position: absolute;
    top: 0;
    right: 0;
}

.cursor_content_manage_banner_list {
    cursor: pointer;
}

.image_preview_content_manage_banner_list {
    margin: auto;
}
</style>
